import { OrderMetadata } from "@web-app/types";
import http from "@web-app/utils/http";

export const getOrderMetadata = (orderId: string): Promise<OrderMetadata> => {
  return http
    .get(`/orders/${orderId}/metadata`)
    .then((response) => response.data);
};
